<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import Game from './components/Game.vue'

export default {
  name: "App",
  components: {
    // Game
  },
};
</script>

<style>
* {
  font-family: Calibri, sans-serif;
}

:root {
  --lightgreen: #279b3c;
  --green: #2b6536;
  --darkgreen: #1c4022;
  --darkred: #800000;
  --doblhoferRed: #ac0a42;
}

.pointer {
  cursor: pointer;
}
</style>
